import { LIBRARY } from '../../const';

export let checkFiltersApplied = currentFilters => {
  let primaryFilter = currentFilters[LIBRARY.FILTER_TYPE.PRIMARY_FILTER];
  let secondaryFilter = currentFilters[LIBRARY.FILTER_TYPE.SECONDARY_FILTER];
  let tertiaryFilter = currentFilters[LIBRARY.FILTER_TYPE.TERTIARY_FILTER];
  let othersFilter = currentFilters[LIBRARY.FILTER_TYPE.OTHERS_FILTER];

  const arePrimaryFilters = primaryFilter && primaryFilter.length;
  const areSecondaryFilters = secondaryFilter && secondaryFilter.length;
  const areTertiaryFilters = tertiaryFilter && tertiaryFilter.length;
  const areOthersFilters = othersFilter && othersFilter.length;
  return arePrimaryFilters || areSecondaryFilters || areTertiaryFilters || areOthersFilters;
};

export let getFilter = (filters, idFilter) => {
  let filterResult = {
    metadataType: LIBRARY.FILTER_TYPE.OTHERS_FILTER,
    id: -1
  };
  if (filters) {
    for (let id = 0; id < filters.length; id++) {
      let filter = filters[id];
      if (filter.metadataValues && filter.metadataValues.length) {
        for (let idMeta = 0; idMeta < filter.metadataValues.length; idMeta++) {
          let metadataValue = filter.metadataValues[idMeta];
          if (metadataValue.id === idFilter) {
            filterResult = metadataValue;
            filterResult.metadataName = filter.name;
            filterResult.metadataType = filter.metadataFilterType;
          }
        }
      }
    }
  }
  return filterResult;
};

export let getPrimaryMetadata = metadatas => {
  return metadatas.filter(metadata => metadata.metadataFilterType === LIBRARY.FILTER_TYPE.PRIMARY_FILTER)[0];
};

export let hasToRenderPlaceHolder = (primaryMetadata, primaryBooks) => {
  if (primaryBooks && primaryBooks.length > 0 && primaryBooks.books && primaryBooks.books.length > 0) {
    return false;
  }
  const sent = primaryMetadata && primaryBooks.length < primaryMetadata.metadataValues.length;
  return !primaryBooks || primaryBooks.length === 0 || sent;
};

let getMetaIfIsPrimaryBook = book => {
  let result;
  for (let idMeta = 0; idMeta < book.metadata.length; idMeta++) {
    let meta = book.metadata[idMeta];

    if (meta.metadataFilterType === LIBRARY.FILTER_TYPE.PRIMARY_FILTER) {
      result = meta;
    }
  }

  return result;
};

export let getPrimaryBooks = (books = []) => {
  let primaryBooks = [];
  for (let i = 0; i < books.length; i++) {
    let metadata = getMetaIfIsPrimaryBook(books[i]);
    if (metadata && metadata.id) {
      if (!primaryBooks[metadata.id]) primaryBooks[metadata.id] = [];
      if (books[i]) primaryBooks[metadata.id].push(books[i]);
    }
  }

  return primaryBooks;
};
